import {BaseEffect} from './base.effect';
import {Injectable} from '@angular/core';
import {Actions, createEffect,  ofType} from '@ngrx/effects';
import {SendBackResult} from '../models/send-back-result';
import {ArrayResponse} from '../models/array-response';
import {Router} from '@angular/router';
import {debug} from '../../../rxjs-operators';
import {catchError, map, switchMap, take} from 'rxjs/operators';
import {error, User} from '..';
import {LoadUsersFailAction, LoadUsersSuccessAction, usersActionTypes} from '../actions/users';
import {UsersService} from '../services/users.service';
import {L10nTranslationService} from 'angular-l10n';

@Injectable()
export class UsersEffect extends BaseEffect {


  load$ = createEffect(() => { return this.actions$.pipe(
    ofType(usersActionTypes.LOAD),
    debug('Users load action received.'),
    switchMap(() => this.usersService.getList().pipe(
      map((payload: SendBackResult<ArrayResponse<User>>) => new LoadUsersSuccessAction(payload.data.array)),
      catchError(res => this.catchResponseError(res)),
    )),
    take(1)
  )});


  loadFail$ = createEffect(() => { return this.actions$.pipe(
    ofType(usersActionTypes.LOAD_FAIL),
    debug('A server error occurred while retrieving products list.'),
    map((action: LoadUsersFailAction) =>
      error(this.translation.translate('PRODUCTS_LOAD_ERROR') + '  ' + action.payload, this.translation.translate('TOAST_ERROR_TITLE')))
  )
  });

  constructor(private actions$: Actions,
              private translation: L10nTranslationService,
              private usersService: UsersService,
              router: Router) {
    super(router);
  }

  protected handleUnhandledError = (response) => {
    return new LoadUsersFailAction(response['error'].message);
  }

  protected handleGoneError = (response) => {
    return new LoadUsersFailAction(response['error'].message);
  }
}
